import { Router } from 'next/router';
import { ComponentPropsWithRef, FC, useEffect } from 'react';
import { useAuthModal } from '@auth/business/AuthModal.hook';
import { BasicLink } from '@components/buttons/BasicLink/BasicLink.component';
import { SecondaryButton } from '@components/buttons/FlatButton/FlatButton.component';
import { Text } from '@components/Text/Text.component';
import { CASectionPopUp } from '@landingPagePro/components/CASectionPopUp/CASectionPopUp.component';
import { useClassNames } from '@styles/breakpoints';
import { urlEnum } from '@utils/url';

export interface SignInSignUpPopinProps extends ComponentPropsWithRef<'div'> {
  close: () => void;
}

const SignInSignUpPopin: FC<SignInSignUpPopinProps> = ({ className, close, ...rest }) => {
  const { showSignInModal } = useAuthModal();
  const buttonsClass = useClassNames({ all: ['flex', 'plc-mt-basis', 'space-between', 'column'], s: ['row'] });
  const signUpMessageClass = useClassNames({
    all: ['flex', 'column', 'space-between', 'plc-mt-basis'],
    s: ['row', 'plc-mt-0', 'align-center'],
  });

  const handleOnClick = (fn: () => void) => {
    fn();
    close();
  };

  useEffect(() => {
    Router.events.on('routeChangeComplete', () => close());

    return () => {
      Router.events.off('routeChangeComplete', () => close());
    };
  }, []);

  return (
    <div {...rest}>
      <CASectionPopUp />
      <div className={buttonsClass}>
        <SecondaryButton
          // eslint-disable-next-line react/jsx-no-bind
          onClick={() => handleOnClick(showSignInModal)}
          textProps={{
            alignment: 'center',
            i18nKey: 'actu.become-pro.signin',
          }}
        />
        <Text className={signUpMessageClass} i18nKey="auth.not-signed-up" variant="small">
          <BasicLink
            as={urlEnum.signUp}
            className="plc-ml-up-s-xs"
            href={urlEnum.signUp}
            isUnderlined
            onClick={close}
            textProps={{ flavour: 'red', i18nKey: 'auth.sign-up.link' }}
          />
        </Text>
      </div>
    </div>
  );
};

export { SignInSignUpPopin };
